<template>
    <InputText
        ref="inputTextRef"
        :value="localValue"
        :label="documentLabel"
        :name="validationName"
        :rules="validationRules"
        :disabled="!type || disabled"
        :maxlength="maxlength"
        @input="onInput"
        @change="onChange"
    />
</template>

<script setup>
    import { ref, computed, watch } from 'vue';
    import InputText from '@/modules/front/ui/InputText.vue';

    const props = defineProps({
        value: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: null
        },
        index: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: true
        },
        inputId: {
            type: String,
            default: null
        }
    });

    const emit = defineEmits(['input', 'change']);

    const inputTextRef = ref(null);
    const localValue = ref(props.value || '');

    watch(() => props.value, newVal => {
        localValue.value = newVal || '';
    });

    function onInput(val) {
        localValue.value = val;
        emit('input', val);
    }

    function onChange(val) {
        localValue.value = val;
        emit('change', val);
    }

    const documentLabel = computed(() => {
        switch (props.type) {
            case 'DNI':
            case 'NIE':
            case 'NIF':
            case 'PASAPORTE':
                return props.type;
            default:
                return 'Documento';
        }
    });

    const validationName = computed(() =>
        `${documentLabel.value}${props.index > 0 ? ` ${props.index}` : ''}`
    );

    const maxlength = computed(() => {
        if (props.type === 'DNI' || props.type === 'NIE' || props.type === 'NIF') {
            return 20;
        }
        return null;
    });

    const validationRules = computed(() => {
        if (!props.type) return '';

        if (props.type === 'NIF') {
            return {
                required: props.required,
                valid_nif_cif: true
            };
        }

        if (props.type === 'OTROS') {
            return {
                required: props.required
            };
        }

        return {
            required: props.required,
            identificacion: { tipo: props.type }
        };
    });
</script>
